export default __webpack_public_path__ + "static/media/devashish.fe771e36.jpg";